import ActionTypes from '../constants/ActionTypes';

const initialState = {
  isInitializing: true,
  globalError: null,
  config: null,
  boardScrollFull: false,
};

// eslint-disable-next-line default-param-last
export default (state = initialState, { type, payload }) => {
  switch (type) {
    case ActionTypes.LOGIN_INITIALIZE:
      return {
        ...state,
        isInitializing: false,
        config: payload.config,
      };
    case ActionTypes.LOGIN_INITIALIZE_SSO:
      return {
        ...state,
        config: payload.config,
      };
    case ActionTypes.AUTHENTICATE__SUCCESS:
    case ActionTypes.USING_OIDC_AUTHENTICATE__SUCCESS:
      return {
        ...state,
        isInitializing: true,
      };
    case ActionTypes.CORE_INITIALIZE:
      return {
        ...state,
        isInitializing: false,
        isMobile: payload.isMobile,
      };
    case ActionTypes.HANDLE_RESIZE:
      return {
        ...state,
        isMobile: payload.isMobile,
      };
    case ActionTypes.CORE_INITIALIZE__CONFIG_FETCH:
      return {
        ...state,
        config: payload.config,
      };
    case ActionTypes.GLOBAL_ERROR:
      return {
        ...state,
        globalError: payload.error,
      };
    case ActionTypes.BOARD_SET_SCROLL_MODE:
      return {
        ...state,
        boardScrollFull: payload.value,
      };
    default:
      return state;
  }
};
